<template lang="html">
<!-- this component hits project_list and allow autocomplete/search of projects -->
  <v-select
    solo
    cache-items
    autocomplete
    class="select"
    placeholder="Type to search a project"
    :search-input.sync="projectInput"
    :items="projects"
    item-text="project_name"
    item-value="project_id"
    :value="value"
    @input="(v) => $emit('input', v)"
  >
  </v-select>
</template>

<script>
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import { getProjectList } from '@/api';

export default {
  props: {
    value: [String, Number, Object],
    onlymine: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      projects: [],
      projectInput: null,
    };
  },
  methods: {
    throttledSearchProjects: throttle(function throttledSearchProjects(value) {
      this.searchProjects(value);
    }, 1000),
    searchProjects: async function searchProjects(val) {
      const userToken = this.$store.getters['auth/userToken'];
      const { data } = await getProjectList(
        userToken,
        { projectName: val, onlymine: this.onlymine },
      );
      const projects = get(data, '[1].data.details', []);
      this.projects = projects.map(p => ({ ...p, project_name: p.project_name || '' }));
    },
  },
  watch: {
    projectInput(val) {
      if (val && val.length >= 3) {
        this.throttledSearchProjects(val);
      }
    },
  },
  mounted() {
    // call search project by default to fetch list of all the projects
    // this enables to show the name of the selected project in case of edits
    this.searchProjects();
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/ProjectSearch.vue